'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002emath$002e$002dBig$002dInt from "./scala.math.-Big-Int.js";
var $p;
/** @constructor */
function $c_Lsamples_SimpleSample$package$$anon$6(evaluator$7) {
  this.M9 = null;
  this.M9 = evaluator$7;
}
export { $c_Lsamples_SimpleSample$package$$anon$6 as $c_Lsamples_SimpleSample$package$$anon$6 };
$p = $c_Lsamples_SimpleSample$package$$anon$6.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_SimpleSample$package$$anon$6;
/** @constructor */
function $h_Lsamples_SimpleSample$package$$anon$6() {
}
export { $h_Lsamples_SimpleSample$package$$anon$6 as $h_Lsamples_SimpleSample$package$$anon$6 };
$h_Lsamples_SimpleSample$package$$anon$6.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.M9.h();
  return ((v instanceof $j_scala$002emath$002e$002dBig$002dInt.$c_s_math_BigInt) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_SimpleSample$package$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_SimpleSample$package$$anon$6, "samples.SimpleSample$package$$anon$6", ({
  qX: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_SimpleSample$package$$anon$6 as $d_Lsamples_SimpleSample$package$$anon$6 };
